import { AssignableUserRoleSchema } from '@joyful/utils'

const ROLE_IMPERSONATION_STORAGE_KEY = 'joyful.roleImpersonation'
const JOYFUL_ADMIN_ROLE = 'JOYFUL_ADMIN'

export function getImpersonatedRole() {
  const storedValue = window.sessionStorage.getItem(
    ROLE_IMPERSONATION_STORAGE_KEY,
  )
  const parsedRole = AssignableUserRoleSchema.schema.safeParse(storedValue)
  if (parsedRole.success === false || parsedRole.data === JOYFUL_ADMIN_ROLE) {
    return null
  }

  return parsedRole.data
}

export function setImpersonatedRole(role: string | null) {
  if (role === null || role === JOYFUL_ADMIN_ROLE) {
    window.sessionStorage.removeItem(ROLE_IMPERSONATION_STORAGE_KEY)
    return
  }

  sessionStorage.setItem(ROLE_IMPERSONATION_STORAGE_KEY, role)
}
